import { ApiClientService, EntityApiService, RequestConfig, SearchResponseType } from '@dfl/react-security';
import { FilterFactory } from '@dofleini/query-builder';
import { ClientType, IClient } from 'modules/client/management/interfaces';

class ClientService extends EntityApiService<IClient> {
  searchClients = (params?: any, config?: RequestConfig | undefined): Promise<SearchResponseType<IClient>> => {
    const filters = FilterFactory.add(
      {
        field: 'type',
        value: ClientType.STRUCTURE,
      },
      {},
    );
    params.filters = filters;
    return this.search(params, config);
  };

  searchEstablishments = (params?: any, config?: RequestConfig | undefined): Promise<SearchResponseType<IClient>> => {
    const filters = FilterFactory.add(
      {
        field: 'type',
        value: ClientType.ESTABLISHMENT,
      },
      {},
    );
    params.filters = filters;
    return this.search(params, config);
  };

  updatePersonalInfo = (_id: string, params: IClient, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${_id}`), params, config));
  };
}
export default new ClientService('/ms-auth/api/space');
